import Axios from 'axios'
import { API_HOST_TOKEN } from '../constants/appConstants'
import { GET_SCREEN_CONTENT, BASE_API } from '../constants/restConstants'

const config = {
  headers: { Authorization: `Bearer ${API_HOST_TOKEN}` },
}

export const getScreenContent = (screenId, contentTypes = []) => {
  const populateTypeQuery = contentType =>
    contentType === 'playlists'
      ? `populate[${contentType}][populate][contents][populate]=*`
      : `populate[${contentType}][populate]`
  const params = contentTypes.reduce((acc, current) => {
    acc[populateTypeQuery(current)] = '*'
    return acc
  }, {})
  // params['populate[ContentOrder][populate]'] = '*'

  return Axios.get(GET_SCREEN_CONTENT(screenId), { ...config, params })
}

export const getScreens = () => Axios.get(`${BASE_API}/screens`, config)

export const getZone = screenId => {
  return Axios.get(GET_SCREEN_CONTENT(screenId), config)
}
